module.exports = __webpack_public_path__ + "static/media/grid_badge.148bfba5.svg";